import React from 'react';

interface CustomTextareaProps {
  label: string;
  id: string;
  value: string;
  onChange: (v: string) => void;
  maxLength?: number;
  rows?: number;
  className?: string;
}

const CustomTextarea: React.FC<CustomTextareaProps> = React.memo(({ label, id, value, onChange, maxLength, rows = 3, className }) => (
  <div className={`display-flex flex-column ${className || 'form-group'}`}>
    <label htmlFor={id}>{label}</label>
    <textarea
      id={id}
      className="form-control"
      value={value}
      onChange={e => onChange(e.target.value)}
      maxLength={maxLength}
      rows={rows}
    />
  </div>
));

export default CustomTextarea; 